export const dataEditAdapter = (data, quantity) => {
	return {
		items: [
			{
				code_internal: data?.record?.code_internal,
				price: data?.record?.unit_price,
				quantity: quantity || data?.record?.quantity,
			},
		],
	};
};
